// @ts-nocheck
import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { productNumbers } from "@store/Themes/common/props/product";
import merge from "lodash/merge";

merge(productPartNumbersStyles, {
    container: productNumbers.container,
    erpNumberLabelText: productNumbers.labelText,
    erpNumberValueText: productNumbers.valueText,
    customerNameLabelText: productNumbers.labelText,
    customerNameValueText: productNumbers.valueText,
    manufacturerItemLabelText: productNumbers.labelText,
    manufacturerItemValueText: productNumbers.valueText,
});
